import {url} from "./urls"

const apiUrl = url.api


export const sendExhibitorInvite =  async ({company, event, email, invite}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "company": company,
    "eventName":event.name,
    "location":event.city,
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.location,
    "footer":event.footer,
    "eventLocation":event.city,
    "eventDate":event.date,
    "eventStart":event.startTime,
    "eventEnd":event.endTime,
    "eventAddress":event.address,
    "email": email,
    "invite": invite
  })
  try {
    await fetch(apiUrl + "/sendExhibitorEmail",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    return {status: 'failed'}
  }
}

export const sendGuestConfirm = async ({fullName, email, event, guestId}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "fullName": fullName,
    "eventName":event.name,
    "eventLocation":event.city,
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.location,
    "footer":event.footer,
    "email": email,
    "guestId": guestId,
  })
  try {
    await fetch(apiUrl + "/sendGuestConfirm",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    return {status: 'failed'}
  }
}

export const sendGuestQrCode = async ({email, event, qrUrl}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventName": event.name,
    "eventLocation":event.city,
    "eventDate":event.date,
    "eventStart":event.startTime,
    "eventAddress":event.address,
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.location,
    "footer":event.footer,
    "email": email,
    "qrUrl":qrUrl
  })
  await fetch(apiUrl + "/sendGuestQrCode",{
    method:'post',
    headers:myHeaders,
    body:body,
    redirect:'follow',
  })
}

export const sendMeetingNotification = async ({guest, event, email, brands}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "guestName": guest.name,
    "guestCompany": guest.company,
    "guestEmail":guest.email,
    "guestPhone":guest.phone,
    "eventLocation":event.city,
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.location,
    "footer":event.footer,
    "email": email,
    "brands":brands,
  })
  await fetch(apiUrl + "/sendMeetingNotification",{
    method:'post',
    headers:myHeaders,
    body:body,
    redirect:'follow',
  })
}

export const sendOrganizerInvite = async({inviteId, email})=>{
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "invite": inviteId,
    "email": email,
  })
  try {
    await fetch(apiUrl + "/sendOrganizerInvite",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const sendStaffInvite = async ({inviteId, email, company, fullName, event}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.location,
    "footer":event.footer,
    "inviteId":inviteId,
    "email":email, 
    "eventName":event.name,
    "company":company,
    "fullName":fullName
  })
  try {
    await fetch(apiUrl + "/sendStaffInvite",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const sendGuestGiveawayNotification = async ({email, event}) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "email":email,
    "footer":event.footer,
    "banner":event.emailImages.banner,
    "locationImage":event.emailImages.locationImage,
    "eventLocation":event.city
  })
  try {
    await fetch(apiUrl + "/sendGuestGiveawayNotification",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const sendGuestGroupAction = async ({email, event, action}) => {
  const myHeaders = new Headers()
  console.log(email, event, action)
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "email":email,
    "banner":event.emailImages.banner,
    "subject":action.subject,
    "body":action.body,
    "attachment": action.attachment
  })
  try {
    await fetch(apiUrl + "/sendGuestGroupAction",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}


// EnvialoSimple // 

export const newEventMail = async (eventId, event) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
    "banner":event.emailImages.banner,
    "footer":event.footer,
    "locationImage":event.emailImages.location,
    "eventLocation":event.region,
    "eventName":event.name,
    "eventAddress":event.address,
    "eventCity":event.city,
    "eventDate":event.date,
    "eventStart":event.startTime,
  })
  try {
    await fetch(apiUrl + "/newEvent",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const deleteEventMail = async (eventId) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
  })
  try {
    await fetch(apiUrl + "/deleteEvent",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const newGuestContact = async (eventId, event, email) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
    "banner":event.emailImages.banner,
    "footer":event.footer,
    "locationImage":event.emailImages.location,
    "eventLocation":event.region,
    "eventName":event.name,
    "eventAddress":event.address,
    "eventCity":event.city,
    "eventDate":event.date,
    "eventStart":event.startTime,
    "email":email
  })
  try {
    await fetch(apiUrl + "/newGuestContact",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}


export const setOrganizerContact = async (email) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "email":email
  })
  try {
    await fetch(apiUrl + "/setOrgContact",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const setExhibitorContact = async (eventId, email) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
    "email":email
  })
  try {
    await fetch(apiUrl + "/setExhContact",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const setStaffContact = async (eventId, email) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
    "email":email
  })
  try {
    await fetch(apiUrl + "/setStaffContact",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    return {status:'success'}
  } catch (error) {
    console.log(error)
    return {status: 'failed'}
  }
}

export const setReminderAction = async (actionId, eventId, time) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":eventId,
    "actionId":actionId,
    "time":time
  })
  try {
    const res = await fetch(apiUrl + "/setReminderAction",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    let {message} = await res.json()
    console.log(message)
    return {status:res.status, message:message}
  } catch (error) {
    return {status: 'failed'}
  } 
}

export const vipArrivalMail = async (guest, event, emails) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  const body = JSON.stringify({
    "eventId":guest.event,
    "guestName":guest.name,
    "guestCompany":guest.company,
    "footer":event.emailImages.banner,
    "to": emails
  })
  try {
    const res = await fetch(apiUrl + "/vipArrivalMail",{
      method:'post',
      headers:myHeaders,
      body:body,
      redirect:'follow',
    })
    let {message} = await res.json()
    console.log(message)
    return {status:res.status, message:message}
  } catch (error) {
    return {status: 'failed'}
  } 
}
